import _ from 'lodash';
import {util, validate} from 'lvgs-vue-modules';

export default {
  state: {
    validate: {},
  },

  getters: {
    getIsPassValidateByKey: (state) => (key, defaultValue = undefined) => {
      let value = _.get(state.validate, key);
      value = _.isUndefined(value) ? defaultValue : value;

      return value;
    },
  },

  mutations: {
    setPassValidate(state, payload)
    {
      let keys = payload.keys;

      if (! _.isArray(payload.keys)) {
        keys = [payload.keys];
      }

      _.each(keys, (key) => {
        util.vueSet(state.validate, key, true);
      });
    },

    setFailValidate(state, payload)
    {
      let keys = payload.keys;

      if (! _.isArray(payload.keys)) {
        keys = [payload.keys];
      }

      _.each(keys, (key) => {
        util.vueSet(state.validate, key, false);
      });
    },

    deleteValidate (state, key) {
      util.vueDelete(state.validate, key);
    },
  },

  actions: {
    validate: _.debounce(({ commit }, payload) => {
      return validate.passes(payload).then((data) => {
        _.each(data, function (value, key) {
          commit('deleteError', key);
        });
        commit('setPassValidate', {keys:_.keys(data)});
        return Promise.resolve(data);
      }).catch((messages) => {
        commit('setError', messages);
        commit('setFailValidate', {keys:_.keys(messages)});
        commit('setPassValidate', {keys:_.difference(_.keys(payload.data), _.keys(messages))});
        return Promise.reject(messages);
    })}, 200, { leading: true }),

    initializeValidate ({ commit }, payload) {
      return validate.passes(payload).then((data) => {
        commit('setPassValidate', {keys:_.keys(data)});
        return Promise.resolve(data);
      }).catch((messages) => {
        commit('setFailValidate', {keys:_.keys(messages)});
        commit('setPassValidate', {keys:_.difference(_.keys(payload.data), _.keys(messages))});
      });
    },

    /**
     * form入力のonChangeイベント等で走るvalidateアクションと
     * formのsubmit時などに明示的に手動で走らせるバリデーションの結果が混同する場合があるため
     * メソッド自体を分ける。
     *
     * @todo 既存のEFを改修する際にvalidateアクションと処理を共通化
     */
    validateManual ({ commit }, payload) {
      return validate.passes(payload).then((data) => {
        _.each(data, function (value, key) {
          commit('deleteError', key);
        });
        commit('setPassValidate', {keys:_.keys(data)});
        return Promise.resolve(data);
      }).catch((messages) => {
        commit('setError', messages);
        commit('setFailValidate', {keys: _.keys(messages)});
        commit('setPassValidate', {keys: _.difference(_.keys(payload.data), _.keys(messages))});
        return Promise.reject(messages);
      });
    },
  }
};
